import getEnvValue from './getEnvValue';

function isUnitTestEnv() {
  return getEnvValue('JB_UNIT_TEST_ENV') === 'jest';
}

export default isUnitTestEnv;
